import {
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { fadeAnimation } from '@app/animations';
import { FlashService } from '@app/services/flash.service';
import * as AuthActions from '@core/actions/auth.actions';
import * as BusinessActions from '@core/actions/business-unit.actions';
import * as MilestoneActions from '@core/actions/milestone.actions';
import * as fromFollows from '@core/reducers/follow.reducer';
import * as fromRoot from '@core/reducers/root.reducer';
import { Store, select } from '@ngrx/store';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import { debounceTime, takeWhile } from 'rxjs/operators';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css'],
    animations: [fadeAnimation]
})
export class LayoutComponent implements OnInit, OnDestroy {
    // loggedIn$ = this.store.pipe(select(fromRoot.getLoggedIn));
    me$ = this.store.pipe(select(fromRoot.getMePopulated));
    counter$ = this.store.pipe(select(fromRoot.getNotificationsCounter));
    activity$ = this.store.pipe(select(fromRoot.getActivity));
    follows$ = this.store.pipe(select(fromFollows.getFollows));

    _activity;
    _alive = true;
    progressRef: NgProgressRef;
    followYears = []

    @ViewChild('flash', { read: ViewContainerRef })
    container;

    constructor(
	private fs: FlashService,
	private store: Store<any>,
	private ngProgress: NgProgress
    ) {}

    ngOnInit() {
	this.progressRef = this.ngProgress.ref();
	this.fs.registerHost(this.container);
	this.activity$
	    .pipe(
		debounceTime(100),
		takeWhile(() => this._alive)
	    )
	    .subscribe(activity => (this._activity = activity));

	this.me$.pipe(takeWhile(() => this._alive)).subscribe(me => {
	    if (me && me.id) {
		this.store.dispatch(new MilestoneActions.LoadStatuses());
		this.store.dispatch(new BusinessActions.Load())
	    }
	});

        this.follows$.pipe(takeWhile(() => this._alive)).subscribe((follow) => {
            follow.forEach((f) => {
                if(!this.followYears.includes(f.year)){
                    this.followYears.push(f.year)
                }
                if(!this.followYears.includes(2026)){
                    this.followYears.push(2026)
                }
                this.followYears = this.followYears.sort((a, b) => a - b )
            })
        })
    }

    ngOnDestroy() {
	this.progressRef.destroy();
	this._alive = false;
    }

    logout() {
	this.store.dispatch(new AuthActions.Logout());
    }

    public getRouterOutletState(outlet) {
	return outlet.isActivated ? outlet.activatedRoute : '';
    }

    onActivate(e, element) {
	element.scrollTo(0, 0);
    }
}
